import { useMemo } from 'react'
import { BreadType } from 'types/bread'
import { CategoryType } from 'types/category'

const useCategoryNameOfBread = (bread: BreadType, categories: CategoryType[]): string => {
  return useMemo(() => {
    if (!categories || categories.length === 0 || !bread.category) return '未設定'

    if (!bread || bread.category.id === '' || !bread.category) {
      return categories[0].name
    } else {
      const category = categories.find((_category) => _category.category_ref.id === bread.category.id)
      if (!category) return '未設定'
      return category.name
    }
  }, [bread, categories])
}

export default useCategoryNameOfBread
